export default {
    callable: (element: HTMLElement) => {
        let topIsVisible = false;
        createTopObserver();
        createObserver();

        function createTopObserver() {
            let observer;

            let options = {
                root: null,
                rootMargin: '0px',
                threshold: [0, 1],
            };

            let topElement = document.getElementById('start');
            if (topElement) {
                observer = new IntersectionObserver(
                    handleTopIntersect,
                    options
                );
                observer.observe(topElement);
            }
        }

        function handleTopIntersect(entries: IntersectionObserverEntry[]) {
            entries.forEach((entry) => {
                if (entry.intersectionRatio === 1) {
                    topIsVisible = true;
                } else {
                    topIsVisible = false;
                }
            });
        }

        function createObserver() {
            let observer;

            let options = {
                root: null,
                rootMargin: '0px',
                threshold: buildThresholdList(),
            };

            observer = new IntersectionObserver(handleIntersect, options);
            observer.observe(element);
        }
        function buildThresholdList() {
            let thresholds = [];
            let numSteps = 500;

            for (let i = 1.0; i <= numSteps; i++) {
                let ratio = i / numSteps;
                thresholds.push(ratio);
            }

            thresholds.push(0);
            return thresholds;
        }

        function handleIntersect(entries: IntersectionObserverEntry[]) {
            entries.forEach((entry) => {
                const percentage = topIsVisible
                    ? entry.intersectionRatio * 50
                    : 100 - entry.intersectionRatio * 50;

                (entry.target as HTMLElement).style.backgroundPositionX =
                    `${percentage}%`;
            });
        }
    },
};
